import { render, staticRenderFns } from "./FaultGuidanceEdit.vue?vue&type=template&id=54c28bf2&scoped=true"
import script from "./FaultGuidanceEdit.vue?vue&type=script&lang=js"
export * from "./FaultGuidanceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c28bf2",
  null
  
)

export default component.exports